import * as React from 'react';
import { connect } from 'react-redux';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';
import { VegobjekterResult } from '@/domain/vegobjekter/VegobjekterResult';
import { VegSysRefList } from './VegSysRefList';
import { selectFeature } from '@/actions/valgtActions';
import { Vegnettlenke } from '@/domain/vegnett/Vegnettlenke';
import { AreaSummary } from './AreaSummary';

interface TagProps {
    results: VegobjekterResult;
}

interface DispatchProps {
    doSelectFeature: (
        vegobjekt?: Vegobjekt[],
        roadNetLink?: Vegnettlenke[],
        clusterObjekter?: Vegobjekt[],
        color?: string
    ) => void;
}

const mapDispatchToProps = {
    doSelectFeature: selectFeature,
};

type Props = TagProps & DispatchProps;
class RoadRefOrAreaSummaryComponent extends React.PureComponent<Props> {
    render() {
        const { results } = this.props;
        if (!(results instanceof VegobjekterResult)) return null;

        if (results.vegobjekter.length > 0) {
            return (
                <div className="c-results-summary__content">
                    <VegSysRefList
                        vegobjekter={results.vegobjekter.filter(
                            vegobjekt => !!vegobjekt?.geometri?.wkt
                        )}
                        onObjectClick={(vegobjekt: Vegobjekt) =>
                            this.onRoadObjectClick(vegobjekt)
                        }
                    />
                </div>
            );
        } else if (results.areaStatistics[0]?.antall === -1) {
            return (
                <p className="c-results-summary__empty-state">
                    Zoom inn for liste over vegsystemreferanser
                </p>
            );
        } else if (results.areaStatistics.length > 0) {
            return (
                <div className="c-results-summary__content">
                    <AreaSummary statistics={results.areaStatistics} />
                </div>
            );
        }
        return null;
    }

    private onRoadObjectClick(vegobjekt: Vegobjekt) {
        this.props.doSelectFeature([vegobjekt], [], []);
    }
}

export const RoadRefOrAreaSummary = connect(
    null,
    mapDispatchToProps
)(RoadRefOrAreaSummaryComponent);
